import { useGetImageById } from '../../../../../../api/media'

// Resolves a status icon's image URL. Prefers `style.imageId` (looked up via
// `media/get-image-by-id`) and falls back to a directly-set `style.imageUrl`.
// Always invokes the hook so hook order stays consistent across renders.
export default function useStatusImageUrl (style) {
  const { data } = useGetImageById(style?.imageId)
  return data?.image?.imageUrl || style?.imageUrl || null
}
